export default __webpack_public_path__ + "static/media/uk.5a8d5196.svg";